import { Map as map } from 'immutable';
const C = require("../constants");

function PrinterSettingsModalReducer(state = map(), action) {
    switch (action.type) {
        case C.OPEN_MODAL_PRINTER_SETTINGS:
            return action.modal;
        default:
            return state;
    }
}

export default PrinterSettingsModalReducer;


// WEBPACK FOOTER //
// ./src/reducers/PrinterSettingsModalReducer.js